import { createBeam } from "@randajan/bifrost/client/beam";
import { bifrost } from "../bifrost";


export const webReviewsBeam = createBeam(bifrost, "/web/reviews");
